export const USE_WEB_AGENT = "use_web_agent";
export const FREE_UNLIMITED_USAGE = "free_unlimited_usage";
export const EMAIL_INBOX = "email_inbox";
export const CMDK = "use_cmdk";
export const DEV_TOOLS = "use_dev_tools";
export const LIGHT_MODE = "light_mode";
export const CHAT_APP = "chat_app";
export const USER_CATEGORIES = "user_categories";
export const SUMMARY_TOOLTIP = "summary_tooltip";
export const CAN_DELETE_OWN_ACCOUNT = "can_delete_own_account";
export const ENABLE_READ_STATUSES = "enable_read_statuses";
export const ENABLED_INTEGRATIONS = "enabled_integrations";
export const ENABLE_IMPERSONATION = "enabled_impersonation";
export const DAILY_BRIEF = "daily_brief";
export const ENABLE_THREAD_LABELS = "enable_thread_labels";
export const CREATE_DRAFT_IN_GMAIL = "create_draft_in_gmail";
export const RICHTEXT_EDITOR_V2 = "richtext_editor_v2";
export const HARD_PAYWALL = "hard_paywall";
export const WRITING_EXAMPLES = "writing_examples";
